import {
  cilAddressBook,
  cilArrowBottom,
  cilArrowRight,
  cilArrowTop,
  cilBan,
  cilBell,
  cilBook,
  cilChartLine,
  cilCode,
  cilCommentSquare,
  cilCursor,
  cilCopy,
  cilDescription,
  cilDoubleQuoteSansLeft,
  cilExternalLink,
  cilEqualizer,
  cilHome,
  cilList,
  cilListNumbered,
  cilLockLocked,
  cilMagnifyingGlass,
  cilMenu,
  cilNewspaper,
  cilPaperclip,
  cilPenAlt,
  cilPenNib,
  cilPencil,
  cilPeople,
  cilScreenDesktop,
  cilSearch,
  cilSpeedometer,
  cilSettings,
  cilTask,
  cilTerminal,
  cilTextSize,
  cilTrash,
  cilUser,
} from '@coreui/icons'

export const iconsSet = Object.assign(
  {},
  {
    cilAddressBook,
    cilArrowBottom,
    cilArrowRight,
    cilArrowTop,
    cilBan,
    cilBell,
    cilBook,
    cilChartLine,
    cilCode,
    cilCommentSquare,
    cilCursor,
    cilCopy,
    cilDescription,
    cilDoubleQuoteSansLeft,
    cilExternalLink,
    cilEqualizer,
    cilHome,
    cilList,
    cilListNumbered,
    cilLockLocked,
    cilMagnifyingGlass,
    cilMenu,
    cilNewspaper,
    cilPaperclip,
    cilPenAlt,
    cilPenNib,
    cilPencil,
    cilPeople,
    cilScreenDesktop,
    cilSpeedometer,
    cilSearch,
    cilSettings,
    cilTask,
    cilTerminal,
    cilTextSize,
    cilTrash,
    cilUser,
  },
  {},
  {},
)
